sap.ui.requireSync("jquery.sap.resources");
